'use strict';
var _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};
var PZSubTab = function PZSubTab(props) {
    var pzSubTab = props.pzSubTab;
    var pzSubDisplay = pzSubTab && JSON.parse(pzSubTab.additional_data);
    if (props.pzHideTabs.includes(pzSubTab.promize_tab_id)) {
        return '';
    }
    return React.createElement(
        'div', {
            id: pzSubTab.promize_tab_id,
            className: pzSubDisplay && pzSubDisplay.inherit && pzSubDisplay.inherit != 0 ? 'pz-custom-items pz-secondary-items open' : 'pz-custom-items pz-secondary-items hide'
        },
        React.createElement(
            'div', {
                className: 'pz-custom-item-header'
            },
            pzSubTab.tab_icon && React.createElement(
                'div', {
                    className: 'pz-tab-icon'
                },
                React.createElement('img', {
                    src: props.pzImgUrl.concat(pzSubTab.tab_icon),
                    style: {
                        width: 20,
                        height: 20
                    }
                })
            ),
            React.createElement(
                'h4', {
                    className: 'pz-item-header'
                },
                React.createElement(
                    'span', {
                        className: 'pz-item-title-text'
                    },
                    pzSubTab.tab_name
                )
            )
        ),
        React.createElement(
            'div', {
                className: "pz-custom-item-body"
            },
            React.createElement(PromizeAttribute, _extends({
                pzSubTab: pzSubTab
            }, props))
        )
    );
};
